var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "114px",
    viewBox: "0 0 114 114",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-page-error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-663.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(665.000000, 307.000000)",
    stroke: "#05C3DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fill: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 55,
    cy: 55,
    r: 55
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(25.000000, 33.000000)",
    fill: "#05C3DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,40 L28.739,40 C28.469,40 28.211,40.109 28.023,40.302 L20,48.54 L20,41 C20,40.448 19.552,40 19,40 L2,40 L2,2 L58,2 L58,40 Z M59,0 L1,0 C0.448,0 0,0.448 0,1 L0,41 C0,41.552 0.448,42 1,42 L18,42 L18,51 C18,51.407 18.247,51.773 18.624,51.926 C18.746,51.976 18.873,52 19,52 C19.265,52 19.524,51.895 19.716,51.698 L29.161,42 L59,42 C59.552,42 60,41.552 60,41 L60,1 C60,0.448 59.552,0 59,0 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,26 C29.552,26 30,25.552 30,25 L30,10 C30,9.448 29.552,9 29,9 C28.448,9 28,9.448 28,10 L28,25 C28,25.552 28.448,26 29,26",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,33 C30.103,33 31,32.103 31,31 C31,29.897 30.103,29 29,29 C27.897,29 27,29.897 27,31 C27,32.103 27.897,33 29,33",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessage);
export default __webpack_public_path__ + "static/media/error-message.ec25f08245ca39f6485f19ae0798f1cf.svg";
export { ForwardRef as ReactComponent };